/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import DvsnFormBuilderInAppService from "./api/dvsn-form-builder.in-app.service";
import DvsnFormBuilderErrorHandlerService from "./api/dvsn-form-builder.error-handler.service";

const { Application } = Shopware;

Application.addServiceProvider('dvsnFormBuilderInAppService', (container) => {
    const initContainer = Application.getContainer('init');
    return new DvsnFormBuilderInAppService(initContainer.httpClient, container.loginService);
});

Application.addServiceProvider('dvsnFormBuilderErrorHandlerService', (container) => {
    return new DvsnFormBuilderErrorHandlerService();
});
